<template>
  <BaseCardV2
    :has-btn-action="false"
    :titre="titre"
    class="pa-2"
  >
    <BaseLoader v-if="loading" />
    <BaseMessageServerError v-if="erreur && !loading" />
    <div
      v-if="!loading"
      class="my-2"
    >
      <RepartitionValueDoughnut
        :value="selected && selected.code"
        :data="{
          items: parts,
          value: repartition && repartition.codeParametreAdherent
        }"
      />
    </div>
  </BaseCardV2>
</template>
<script>
/*
 * Composant unique de repartition, remplacant cinq fichiers quasi identiques
 * (stockeur, potentiel de sol, type de production, type d'exploitation,
 * ressource effluent). Ils ne differaient que par un titre et le nom des
 * donnees ; le calcul, lui, etait recopie a l'identique - defaut compris.
 *
 * Le composant ne connait plus le store : le parent, qui sait de quelle
 * repartition il s'agit, lui passe le referentiel et les donnees. C'est ce
 * qui rend un seul composant suffisant.
 */
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import RepartitionValueDoughnut from '@/components/chart/v2/repartition-value-doughnut.vue'
import { construireParts } from '@/utils/repartition'

export default {
  name: 'RepartitionParametre',
  components: { BaseCardV2, BaseLoader, BaseMessageServerError, RepartitionValueDoughnut },
  props: {
    titre: {
      type: String,
      required: true
    },
    selected: {
      type: Object,
      default: null
    },
    // Valeurs possibles du parametre : { code, libelle }
    referentiel: {
      type: Array,
      default: () => []
    },
    // Donnees du groupe : { partGroupeEnPourcentageParParametre, codeParametreAdherent }
    repartition: {
      type: Object,
      default: null
    },
    palette: {
      type: Array,
      default: () => ['#DBBD00', '#969A27', '#004C23']
    },
    loading: {
      type: Boolean,
      default: false
    },
    erreur: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    parts () {
      return construireParts(
        this.repartition && this.repartition.partGroupeEnPourcentageParParametre,
        this.referentiel,
        this.palette
      )
    }
  }
}
</script>
